import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LoginFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.42 19.84V4.08H17.96V19.84H8.42ZM11.42 9.82L13.58 11.96L11.42 14.1L12.48 15.16L15.68 11.96L12.48 8.76L11.42 9.82Z" />
    </SvgIcon>
  );
});
